<onyx-modal
  variant="center"
  [heading]="data.heading ?? `${I18N}.heading`"
  [size]="980"
  [close$]="close$"
  [showBottomBar]="!data.readonly"
  (closeModal)="close($event)"
>
  <div class="container" [class.readonly]="data.readonly">
    <form [formGroup]="form">
      @let controls = form.controls;
      <div class="street-container">
        <onyx-text-field
          class="street"
          [formControl]="controls.street"
          [label]="`${I18N}.street`"
        ></onyx-text-field>

        <onyx-text-field
          class="house"
          [formControl]="controls.houseNumber"
          [label]="`${I18N}.houseNumber`"
        ></onyx-text-field>

        <onyx-text-field
          class="house"
          [formControl]="controls.apartmentNumber"
          [label]="`${I18N}.apartmentNumber`"
        ></onyx-text-field>
      </div>

      <div class="city">
        <onyx-text-field
          [formControl]="controls.zipCode"
          [label]="`${I18N}.zipCode`"
        ></onyx-text-field>

        <onyx-text-field
          [formControl]="controls.city"
          [label]="`${I18N}.city`"
        ></onyx-text-field>
      </div>

      <onyx-dropdown
        [formControl]="controls.countryCode"
        [label]="`${I18N}.countryCode`"
        [options]="countries$ | async"
        [search]="true"
      ></onyx-dropdown>

      <onyx-text-field
        [formControl]="controls.coordinates"
        [label]="`${I18N}.coordinates`"
      >
        @if (coordinatesString()) {
          <onyx-icon-button
            action
            variant="transparent"
            color="gray"
            [size]="20"
            [tabindex]="-1"
            (click)="copyCoordinates()"
          >
            <onyx-icon
              class="f-muted"
              name="copy-outlined"
              [size]="20"
            ></onyx-icon>
          </onyx-icon-button>
        }
      </onyx-text-field>
    </form>

    <onyx-map
      [defer]="true"
      [preview]="false"
      [contextMenuOptions]="data.readonly ? null : CONTEXT_MENU_OPTIONS"
    ></onyx-map>
  </div>

  @if (!data.readonly) {
    <onyx-button bottomLeftOptions variant="outlined" (click)="clear()">
      {{ `${I18N}.clear` | translate }}
    </onyx-button>
  }

  <ng-container bottomRightOptions>
    @if (!data.readonly) {
      <onyx-button variant="outlined" (click)="cancel()">
        {{ `${I18N_COMMON}.cancel` | translate }}
      </onyx-button>

      <onyx-button [disabled]="form.invalid || form.disabled" (click)="save()">
        {{ `${I18N}.save` | translate }}
      </onyx-button>
    }
  </ng-container>
</onyx-modal>
